import { Component, OnInit, ViewChild } from '@angular/core';
import { ScrollDetail } from '@ionic/core';  
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {AlertController, IonSlides, MenuController, ModalController, NavController} from "@ionic/angular";
import { Profile, ProfileModel } from 'src/models/profile/profile';
import * as firebase from 'firebase/app';
import { AngularFirestore } from '@angular/fire/firestore';
import { CrudService } from '../../admin/services/crud/crud.service';
import { AccountModel } from 'src/models/accounts/account';
import { ProfileUsersModel } from 'src/models/profile/profile-users/profile-users';
import { BranchModel } from 'src/models/system/branch-collection/branch';
import { BranchTypeCompose, ProfileBranchModel } from 'src/models/system/branch-collection/profile-branch';
import { QuestionModel, QuestionThreadModel } from 'src/models/public-collective/content/question/question';
import { AppointmentModel, Status } from 'src/models/public-collective/appointment/appointment';
import { LanguageModel } from 'src/models/profile/language';
import { SocialMediaModel } from 'src/models/profile/social-media';
import { GraduationModel } from 'src/models/profile/graduation';
import { AwardModel } from 'src/models/profile/award';
import { AppointmentSettings, VideoAppointmentSettings } from 'src/models/profile/profile-users/appointment-settings';

import * as util from 'util' 
import { ar } from 'date-fns/locale';
import { FeedbackModel } from 'src/models/public-collective/appointment/feedback';
import { VideoModel } from 'src/models/public-collective/content/video/video';
import { ArticleModel } from 'src/models/public-collective/content/article/article';
import { InsuranceModel } from 'src/models/profile/profile-users/insurance';

interface AlertInputModel {  name: string, type: "number" | "radio" | "date" | "email" | "password" | "search" | "tel" | "text" | "url" | "time" | "checkbox" | "textarea", label: string, value: any, checked: boolean };

@Component({
  selector: 'app-doctor-profile-type-modal',
  templateUrl: './doctor-profile-type-modal.page.html',
  styleUrls: ['./doctor-profile-type-modal.page.scss'],
})
export class DoctorProfileTypeModalPage implements OnInit {


  @ViewChild('slideWithNav', { static: false }) slideWithNav: IonSlides;

  profilePath;
  profileId;
  profile = {} as ProfileModel;
  profileReference: string;
  languages =[];
  publications = [];
  socialMediaLinks: SocialMediaModel;
  graduations = [] as {name: string, startDate: Date, endDate: Date}[];
  awards = [] as {name: string, imageName: string, imageFilepath: string}[];
  experiences = [] as {name: string, startDate: Date, endDate: Date}[];
  hobbies = [];
  teammates = [] as { name: string, job: string}[];
  services = [];
  account = {} as AccountModel;
  accountRef: string;
  profileUser = {} as ProfileUsersModel;
  appointmentSettings = {} as AppointmentSettings;
  videoAppointmentSettings = {} as VideoAppointmentSettings;
  allUsers = [] as {obj: ProfileUsersModel, ref: string}[];
  activeUser: number = 0;
  branches = [] as { title: string}[];
  clinicImages = [];
  clinicFacilites = [];
  clinicServices = []
  clinicInsurances = [];
  questions = [] as {obj: QuestionThreadModel, ref: string}[];
  feedbacks = [] as {obj: FeedbackModel, account: AccountModel}[];
  rateAvg = 0;
  rateTotal = 0;
  branchesText:string;
  favorite_icon = false;
  tab: string = "about";
  showToolbar = false;  
 Short: string = "1";     
 slider: {
  isBeginningSlide: boolean,
  isEndSlide: boolean,
  slidesItems: string[]
 };
 slideOpts = {
  initialSlide: 0,
  slidesPerView: 1,
  autoplay: true
};


videos = [] as {obj: VideoModel}[];
articles = [] as {obj: ArticleModel, ref: string}[];
insurances = [];

  constructor(private menu: MenuController,
    private route:ActivatedRoute, private router: Router,
    private firestore: AngularFirestore,
    private profileService:CrudService<object,ProfileModel>,
    private accountService: CrudService<object, AccountModel>,
    private profileUserService: CrudService<object, ProfileUsersModel>,
    private profileBranchService: CrudService<object, ProfileBranchModel>,
    private branchTypeService: CrudService<object, BranchTypeCompose>,
    private questionService: CrudService<object, QuestionThreadModel>,
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private feedbackService: CrudService<object, FeedbackModel>,
    private videoService: CrudService<object, VideoModel>,
    private articleService: CrudService<object, ArticleModel>,
    private modalController: ModalController
    ) {

           

     }


     getRates(dataOne: any, dataTwo: any, dataThere: any, dataFour: any) {
       let proRef = this.firestore.collection(dataOne).doc(dataTwo).collection(dataThere).doc(dataFour).ref;
       this.feedbacks = [];
       let count = 0;
       this.firestore.collection('appointments',ref=> ref.where('profileId','==',proRef).where('status','==','completed').where('feedback.status','==','approved').limit(10).orderBy('feedback.rateDate','desc')).get().toPromise().then(res => {
       count = res.docs.length;
        res.docs.forEach((item => {
          let apptFb = item.data() as AppointmentModel;
          this.accountService.findOnePromiseByPath('accounts/'+apptFb.accountId).then(resAcc => {
            let accFb = resAcc as AccountModel;
            this.rateTotal = this.rateTotal + apptFb.feedback.rate;
            console.log(apptFb.feedback.rate);
            this.rateAvg = (this.rateAvg+ apptFb.feedback.rate)/count;
            this.feedbacks.push({obj: apptFb.feedback, account: accFb});
          }).catch(errAcc => {
            console.log(errAcc);
          });          
        }))
        
        console.log(this.rateAvg);
        
       }).catch(err => {
         console.log(err);
       });
     }

     changeClinic(event: any) {
       console.log(event);
       this.activeUser = event.detail.value;
       this.profileUserService.findAllPublicPromiseWithIdReturnObj(this.profilePath+'/profileUsers').then().then(res => {
        this.allUsers = res;
        console.log(this.profileUser);
        this.appointmentSettings = res[this.activeUser].obj.appointmentSettings;
        this.videoAppointmentSettings = res[this.activeUser].obj.videoAppointmentSettings;
        this.profileUser = this.allUsers[this.activeUser].obj;

        this.profileUser.facilities.forEach((element) => {
          this.clinicFacilites.push(element);
        });    

        this.profileUser.clinicService.forEach((element) => {
          this.clinicServices.push(element);
        });

        this.profileUser.images.forEach((element) => {
          this.clinicImages.push(element.imageFilepath);
        });

        this.profileUser.insurances.forEach((element) => {
          element.insuranceId.get().then(resInsurance => {
            this.clinicInsurances.push(resInsurance.data().title);
          }).catch(errInsurance => {
            console.log(errInsurance);
          });
        });

      }).catch(err => {
        console.log(err);
      });
     }


     ionViewWillEnter() {
      this.menu.enable(false);
      
    console.log('asdf');

    /* 
        this.profilePath = this.router.getCurrentNavigation().extras.state.profilePath;
        this.profileId = this.router.getCurrentNavigation().extras.state.profileId; */
        console.log(this.profileId, this.profilePath)
        let arr = this.profilePath.split('/');
        this.accountRef = arr[1];
        this.profileService.findOnePromiseByPath(this.profilePath).then(resProfile => {
          this.profile = resProfile;
          resProfile.languages.lang.forEach((language) => {
            language.ref.get().then(resLang=> {
              this.languages.push(resLang.data().name);
            });
          });
          resProfile.publications.title.forEach((pubTitle) => {
            this.publications.push(pubTitle);
          });

          this.socialMediaLinks = resProfile.socialMediaLinks; 
          resProfile.graduations.graduate.forEach((gradItem) => {
            this.graduations.push({name: gradItem.name, startDate: gradItem.startDate, endDate: gradItem.endDate});
          });
          console.log(this.graduations);
          
          resProfile.awards.award.forEach((awardItem) => {
            this.awards.push(awardItem)
          });

          resProfile.experience.exp.forEach((expItem) => {
            this.experiences.push({name: expItem.name, startDate: expItem.startDate, endDate: expItem.endDate});
          });

          resProfile.hobbies.title.forEach((hobbyItem) => {
            this.hobbies.push(hobbyItem);
          });

          resProfile.teamMates.person.forEach((personItem) => {
            this.teammates.push({name: personItem.name, job: personItem.job});
          });

          resProfile.services.title.forEach((serviceItem) => {
            this.services.push(serviceItem);
          });

         
        

          
          this.profileUserService.findAllPublicPromiseWithIdReturnObj(this.profilePath+'/profileUsers').then().then(res => {
            this.allUsers = res;
            console.log(this.profileUser);
            this.appointmentSettings = res[this.activeUser].obj.appointmentSettings;
            this.videoAppointmentSettings = res[this.activeUser].obj.videoAppointmentSettings;
            this.profileUser = this.allUsers[this.activeUser].obj;

            this.profileUser.facilities.forEach((element) => {
              this.clinicFacilites.push(element);
            });    

            this.profileUser.clinicService.forEach((element) => {
              this.clinicServices.push(element);
            });

            this.profileUser.images.forEach((element) => {
              this.clinicImages.push(element.imageFilepath);

            });

            this.slider =
            {
              isBeginningSlide: true,
              isEndSlide: false,
              slidesItems: this.clinicImages
            };


            this.firestore.collectionGroup('profileInsurances').get().toPromise().then(resInsurances => {
              resInsurances.docs.forEach((insuranceItem) => {
                let elementInsurance = insuranceItem.data() as InsuranceModel;
                elementInsurance.insuranceId.get().then(resTitleData => {
                  this.clinicInsurances.push(resTitleData.data().title);
                }).catch(errTitleData => {
                  console.log(errTitleData);
                });
              })
            }).catch(errInsurances => {
              console.log(errInsurances);
            });

/*               this.profileUser.insurances.forEach((element) => {
              element.insuranceId.get().then(resInsurance => {
                this.clinicInsurances.push(resInsurance.data().title);
              }).catch(errInsurance => {
                console.log(errInsurance);
              });
            }); */

          }).catch(err => {
            console.log(err);
          });

          this.profileBranchService.findAllPublicPromiseWithIdReturnObj(this.profilePath+'/profileBranches').then(resProfileBranches => {
            resProfileBranches.forEach((item) => {
              console.log(item);
              this.branchTypeService.findAllPublicPromise(this.profilePath+'/profileBranches/'+item.ref+'/expertBranches').then(resBranch => {
                if(resBranch.length > 0) {
                  this.branchesText = "";
                }
                resBranch.forEach((branchItems) => {
                  branchItems.branchId.get().then(resBranchTitle => {
                    this.branches.push({title: resBranchTitle.data().title});
                    this.branchesText = this.branchesText + ' ' + resBranchTitle.data().title;
                  }).catch(errGetBranchTitle => {
                    console.log(errGetBranchTitle);
                  });
                }); console.log(this.branches);
                
              }).catch(errBranch => {
                console.log(errBranch);
              });
              
            })
          }).catch(errProfile => {
              console.log(errProfile)
          });

          this.questions = [];
          console.log(this.profileId);
          
          this.questionService.findAllPublicPromiseThreeLayerQuery('questionThreads','isAnswered.profile',this.profileId,'status',Status.approved,'displayPermission',true).then(resQuestion => {
            this.questions = resQuestion;
            console.log(resQuestion);
            
          }).catch(errQuestion => {
            console.log(errQuestion);
          });

          let pathProfile = this.firestore.collection(arr[0]).doc(arr[1]).collection(arr[2]).doc(arr[3]).ref;

          this.firestore.collection('articles', ref =>ref.where('profileRef','==',pathProfile).where('status','==','approved').orderBy('date','desc')).get().toPromise().then(resArticle => {
            if(resArticle.docs.length > 0) {
              resArticle.docs.forEach((itemArtice) => {
                this.articles.push({obj: itemArtice.data() as ArticleModel, ref: itemArtice.id});
              })
            }
          }).catch(errArticle => {
            console.log(errArticle);
          });


          this.firestore.collection('videos', ref =>ref.where('profile','==',pathProfile).where('status','==','approved')).get().toPromise().then(resVideo => {
            if(resVideo.docs.length > 0) {
              resVideo.docs.forEach((itemVideo) => {
                this.videos.push({obj: itemVideo.data() as VideoModel});
              })
            }
          }).catch(errArticle => {
            console.log(errArticle);
          });


          this.getRates(arr[0],arr[1],arr[2],arr[3]);

        }).catch(errProfile => {
            console.log(errProfile)
        });

          this.accountService.findOnePromiseByPath(arr[0] + '/' + arr[1]).then(resAccount => {
            this.account = resAccount;
          }).catch(errAccount => {
            console.log(errAccount);
          });


    }



  ngOnInit() {

  }

  dismiss(){
    this.modalController.dismiss();
  }

 onScroll($event: CustomEvent<ScrollDetail>) {
    if ($event && $event.detail && $event.detail.scrollTop) {
      const scrollTop = $event.detail.scrollTop;
      this.showToolbar = scrollTop >= 150;
    }
  }    
toggleSaveIcon1() {
    this.favorite_icon = !this.favorite_icon;
  }


  

  async chooseClinic(profile: ProfileModel) {

    let dataInputs: AlertInputModel[];
    let allData = this.allUsers;
    let str = "radio";
    let index = 0;
    dataInputs = [];
    allData.forEach((item) => {
      dataInputs.push({name: str+index, type:'radio', label:item.obj.name, value:index+1, checked: false});
      index++;
    });

    const alert = await this.alertCtrl.create({
      cssClass: 'my-custom-class',
      header: 'Choose Clinic',
      inputs: dataInputs,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (alertData) => {
            console.log('Confirm Ok');
            console.log(JSON.stringify(alertData))
            let pUser = this.allUsers[alertData-1];
            let navigationExtras: NavigationExtras = {
              state: {
                  profileUser: pUser.ref,
                  profile: this.profileId,
                  accountRef: this.accountRef
              }
          };
            this.navCtrl.navigateForward(['expert-appointment-view'], navigationExtras);

          }
        }
      ]
    });

    await alert.present();
  }
  

 book_appointment_now(userCount: number, profile: ProfileModel) {
   console.log(profile);
   console.log(userCount);
    if(userCount > 1) {
      this.chooseClinic(profile);
    } else {
      let pUser = this.allUsers[this.activeUser];
      let navigationExtras: NavigationExtras = {
        state: {
            profileUserRef: pUser.ref,
            profileRef: this.profileId,
            accountRef: this.accountRef
        }
    };
    this.navCtrl.navigateForward(['expert-appointment-view'], navigationExtras);
    }
  }
 give_feedback() {
    this.router.navigate(['./addfeedback']);
  }

    ionViewWillLeave() {
        this.menu.enable(true);
    }
    askQuestionPage(){
      this.router.navigate(['ask-question-form-profile']);
    }
    openQuestionDetail(questionRef){
      this.router.navigate(['question-detail']);
      let navigationExtras: NavigationExtras = {
        state: {
          questionThreadId: questionRef
        }
    };
      this.navCtrl.navigateForward(['question-detail'], navigationExtras);
    }
    





  //Move to Next slide
  slideNext(object, slideView) {
    slideView.slideNext(500).then(() => {
      this.checkIfNavDisabled(object, slideView);
    });
  }

  //Move to previous slide
  slidePrev(object, slideView) {
    slideView.slidePrev(500).then(() => {
      this.checkIfNavDisabled(object, slideView);
    });;
  }

  //Method called when slide is changed by drag or navigation
  SlideDidChange(object, slideView) {
    this.checkIfNavDisabled(object, slideView);
  }

  //Call methods to check if slide is first or last to enable disbale navigation  
  checkIfNavDisabled(object, slideView) {
    this.checkisBeginning(object, slideView);
    this.checkisEnd(object, slideView);
  }

  checkisBeginning(object, slideView) {
    slideView.isBeginning().then((istrue) => {
      object.isBeginningSlide = istrue;
    });
  }
  checkisEnd(object, slideView) {
    slideView.isEnd().then((istrue) => {
      object.isEndSlide = istrue;
    });
  }

  articleDetail(articleRef: string){
    let navigationExtras: NavigationExtras = {
      state: {
          articleId: articleRef
      }
  };
    this.navCtrl.navigateForward(['article-detail'], navigationExtras);
  }

}
